import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Labels } from '@core/constants/labels';
import { SlideService } from '@core/services/slide-service/slide-service.service';
import { SelectDropDownModule } from 'ngx-select-dropdown';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-image-filter',
  standalone: true,
  imports: [CommonModule, FormsModule, SelectDropDownModule],
  templateUrl: './image-filter.component.html',
  styleUrl: './image-filter.component.scss',
})
export class ImageFilterComponent implements OnDestroy, OnInit {
  labels = Labels.IMAGE_FILTER;
  subtypeMap = Labels.SLIDE_CLASSIFICATOR.SUBTYPE_MAP as any;
  siteMap = Labels.SLIDE_CLASSIFICATOR.SITE_MAP as any;

  selectionConfig = {
    displayKey: 'title',
    placeholder: this.labels.WAITING_SELECT,
    noResultsFound: this.labels.NO_RESULTS,
    searchOnKey: 'title',
    search: true,
    limitTo: 10,
  };

  //metastasisOptions = Labels.SLIDE_CLASSIFICATOR.METASTASIS_OPTIONS;
  possibleSites: any[] = [];
  possibleSubtypes: any[] = [];

  selectedTissueSites: any[] = [];
  selectedPrimarySites: any[] = [];
  selectedSubtypes: any[] = [];

  cancerStructure: any = null;

  subscriptions = new Subscription();

  constructor(private slideService: SlideService) {}

  ngOnInit() {
    this.updateCancerStructure();
  }

  updateCancerStructure() {
    this.cancerStructure = this.slideService.getCancerStructure();
    this.possibleSites = Object.keys(this.cancerStructure).map((d) => {
      return { title: this.siteMap[d], value: d };
    });
    this.updatePossibleSubtypes([]);
  }

  updatePossibleSubtypes(possible_tissues: string[]) {
    if (this.cancerStructure === null) return;

    const possibilityMap = new Map(); // to remove duplicates
    if (possible_tissues.length === 0) {
      possible_tissues = Object.keys(this.cancerStructure);
    }
    for (let i = 0; i < possible_tissues.length; i++) {
      const subtypes = this.cancerStructure[possible_tissues[i]]
        .subtypes as string[];
      for (let j = 0; j < subtypes.length; j++) {
        possibilityMap.set(subtypes[j], {
          title: this.subtypeMap[subtypes[j]],
          value: subtypes[j],
        });
      }
    }
    this.possibleSubtypes = [];
    for (const data of possibilityMap) {
      this.possibleSubtypes.push(data[1]);
    }
  }

  handleTissueSiteChanged() {
    const selectedValues = this.selectedTissueSites.map((s) => s.value);
    this.updatePossibleSubtypes(selectedValues);
    this.updateFilterData();
  }

  updateFilterData() {
    const currentFilterData = this.slideService.filterData;
    currentFilterData.tissue_site = this.selectedTissueSites.map(
      (s) => s.value,
    );
    currentFilterData.tumor_subtype = this.selectedSubtypes.map((s) => s.value);
    currentFilterData.primary_site = this.selectedPrimarySites.map(
      (s) => s.value,
    );
    this.slideService.updateFilters(currentFilterData);
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
